
import EditLineIcon from '~/assets/images/edit-line-icon.svg?inline'
import FeaturedCard from '~/components/public/featured/featured-card.vue'

export default {
  components: {
    FeaturedCard,
    EditLineIcon,
  },
  props: {
    // Required
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    cta: {
      type: String,
      required: true,
    },
    ctaApply: {
      type: String,
      required: true,
    },
    image: {
      type: Object,
      required: true,
    },
    dateTime: {
      type: String,
      required: true,
    },
    location: {
      type: String,
      required: true,
    },
    slug: {
      type: String,
      required: true,
    },

    // Optional
    orientation: {
      type: String,
      default: 'vertical',
      validator: (value) =>
        ['vertical', 'horizontal'].includes(value.toLowerCase()),
    },

    formLink: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    permaLink() {
      return `/workshops-and-webinars/${this.slug}`
    },

    workshopFormLink() {
      return this.$getLinkFromDato(this.formLink)
    },

    metaInformation() {
      return [
        {
          icon: 'calendar',
          label: this.$gettext('Date and time'),
          value: this.$formatAsDate(this.dateTime, 'dateTime'),
        },
        {
          icon: 'location',
          label: this.$gettext('Location'),
          value: this.location,
        },
      ]
    },
  },
}
